<template>
  <div class="institutions-list-columns-column">
    <div class="institutions-list-card">
      <div class="institutions-list-card-header">
        <div class="institutions-list-avatar">
          <VueSkeletonLoader type="circle" :width="112" :height="112" />
        </div>
        <div class="doctors-list-info">
          <VueSkeletonLoader  class="doctors-list-info-title" :width="300" :height="30" rounded />
          <VueSkeletonLoader class="doctors-list-info-description" :width="200" :height="30" rounded />
        </div>
      </div>
      <div class="doctors-list-card-body">
        <VueSkeletonLoader class="w-100" :height="275" />
      </div>
    </div>
  </div>
</template>

<script>
import VueSkeletonLoader from 'skeleton-loader-vue';

export default {
  name: 'InstitutionListCardSkeleton',
  components: {
    VueSkeletonLoader,
  },
}
</script>